import http from "@/http-common";

/* eslint-disable */
class AgsDataService {
  getSerialNoByTextract(image: any): Promise<any> {
    return http.api.post("/getSerialNoByTextract", image)
  }
  getVinNoByTextract(image: any): Promise<any> {
    return http.api.post("/getVinNoByTextract", image)
  }
  postTieData(tieData: any): Promise<any> {
    return http.api.post("/postTieData", tieData)
  }
  searchTieData(tieData: any): Promise<any> {
    return http.api.post("/searchTieData", tieData)
  }
}
export default new AgsDataService();
